var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{},[_c('the-copyright')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }